import { useEffect, useState } from "react";

interface TabsProps {
  items: {
    label: string;
    content: React.ReactNode;
  }[];
}

export function Tabs({ items }: TabsProps) {
  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    if (activeTab >= items.length) {
      setActiveTab(0);
    }
  }, [activeTab, items]);

  return (
    <div className="flex flex-col">
      <div className="tabs mb-7.5 px-7.5">
        {items.map((item, index) => (
          <button
            key={index}
            onClick={() => setActiveTab(index)}
            className={`tab ${index === activeTab ? "border-b-[#296573] !text-[#296573]" : ""} hover:text-[#296573] text-[#A1A5B7] text-[16px] font-semibold`}
          >
            {item.label}
          </button>
        ))}
      </div>
      {/* Tab content */}
      {items.map((item, index) => (
        <div key={index} className={`${index === activeTab ? "" : "hidden"}`}>
          {item.content}
        </div>
      ))}
    </div>
  );
}
